import * as types from 'modules/notifications/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  size: number,
 *  last?: string,
 * }} ScrollPage
 */

/** @type {ScrollPage} State */
const initialState = {
  size: 10,
  last: undefined,
};

const updateState = (state, { payload = {} }) => {
  const { page } = payload;
  return {
    ...state,
    ...(page ?? initialState),
    last: page.last,
  };
};

/** @returns {State} The updated state */
const resetState = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS]: updateState,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_FAILURE]: resetState,
  [types.RESET_NOTIFICATIONS_DASHBOARD]: resetState,
});
